// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"85":"mobile","339":"storefront"}[chunkId] || chunkId) + "." + {"73":"269018af","85":"7603168a","339":"b5e00b86"}[chunkId] + ".chunk.css";
};